// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"296":"ea88be26","3415":"d0447323"}[chunkId] || chunkId) + "." + {"296":"6fc2bdc0617142ae","780":"023a36ec371c4549","2865":"477b4c0320c4d406","3415":"ed7e95ad70e8710b","4263":"8a09dce177dd7d05","9260":"818e1a065d192c96"}[chunkId] + ".js";
};